import { useEffect, useState } from 'react';
export const ECRANS = [
    { chemin: '/', cle: 'app.mesReservations' },
    { chemin: '/mes-factures', cle: 'app.mesFactures' },
    { chemin: '/mon-abonnement', cle: 'app.monAbonnement' },
    { chemin: '/mes-formations', cle: 'app.mesFormations' },
];
function normaliser(chemin) {
    const sansFinal = chemin.replace(/\/+$/, '');
    return sansFinal === '' ? '/' : sansFinal;
}
export function ecranPour(chemin) {
    const cible = normaliser(chemin);
    return ECRANS.find((e) => e.chemin === cible);
}
/** Chemin courant, tenu à jour par les boutons Précédent/Suivant du navigateur. */
export function useChemin() {
    const [chemin, setChemin] = useState(() => normaliser(window.location.pathname));
    useEffect(() => {
        const surRetour = () => setChemin(normaliser(window.location.pathname));
        window.addEventListener('popstate', surRetour);
        return () => window.removeEventListener('popstate', surRetour);
    }, []);
    const naviguer = (vers) => {
        const cible = normaliser(vers);
        if (cible === chemin)
            return;
        window.history.pushState({}, '', cible);
        setChemin(cible);
        // Chaque changement d'écran ramène le focus en haut : sans cela, un
        // lecteur d'écran resterait sur l'ancien contenu.
        document.getElementById('contenu-principal')?.focus();
    };
    return [chemin, naviguer];
}
//# sourceMappingURL=routeur.js.map